import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import {connect, setStore} from "trim-redux";
import {Translate} from "../../../../../config/Translate";
import {Link} from 'react-router-dom';
import {defaultVariabls} from "../../../../../config";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import SettingsApplicationsRoundedIcon from '@material-ui/icons/SettingsApplicationsRounded';
import PowerSettingsNewRoundedIcon from '@material-ui/icons/PowerSettingsNewRounded';
import {beSupplier} from "../../../../../config/Security";
import GetConfirmationButton from "../../../elements/GetConfirmationButton";
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {truncate} from "../../../../../config/values";
import GetConfirmationText from "../../../elements/GetConfirmationText";
const useStyles = makeStyles((theme) => {
  return {
    crUserInfo: {
      paddingTop: 9,
        backgroundColor:"#151c25",
      paddingBottom: 9,
      minHeight: 56,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      [theme.breakpoints.up('sm')]: {
        paddingTop: 10,
        paddingBottom: 10,
        height: 78,
      },
    },
    profilePic: {
      fontSize: 24,
    },
    userInfo: {
      width: 'calc(100% - 75px)',
    },
    userName: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: 16,
      color: '#fff',
    },
    designation: {
      marginTop: -2,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: theme.palette.text.secondary,
    },
    pointer: {
      cursor: 'pointer',
    },
      link:{
        cursor:"pointer"
      }
  };
});

const UserInfo = (props) => {
    const handleLogout = () => {
        localStorage.removeItem('ACT');
        localStorage.removeItem('RET');
        setStore({
            isAuth : false,
            user : null,
        });
        window.location.replace(`${defaultVariabls.website}/logOutFromPanel`);
    };
  const classes = useStyles();
  let {user,primary_color} = props;
  let url = `${defaultVariabls.uploads}/FileManager/${user.avatar.name}_small.${user.avatar.extension}`;
  if(!!user.shops[0]){
      if(!!user.shops[0].logo){
          url = `${defaultVariabls.uploads}/FileManager/${user.shops[0].logo.name}_small.${user.shops[0].logo.extension}`;
      }
  }
  return (
      <Box
          px={{xs: 2, xl: 4}}
          className={clsx(classes.crUserInfo, 'cr-user-info')}>
          <Grid container spacing={2} alignItems="center" justify="center">
              <Grid item xs={12}>
                  <Grid container spacing={2} alignItems="center" justify="center">
                      <Grid item xs={4} style={{textAlign:'center'}}>
                          <Link to={!!user.shops[0] ? "my-shop" : "/account/details"}>
                          <Avatar style={{width:60,height:60,transform:"translateX(50%)",right:"50%"}}
                                  className={classes.profilePic}
                                  src={url}
                                  alt={user.name}
                          />
                          </Link>
                      </Grid>
                      <Grid item xs={8} style={{padding:0,paddingLeft:8}}>
                          <Typography style={{color:"#fff"}} className="only-one-line" >
                              {user.first_name} {user.last_name}
                          </Typography>
                          <Typography varaint="body2"  style={{fontSize:10,color:"#fff"}}>
                              {user.role.type === "admin" ?
                                  Translate[user.role.name]
                                  :
                                  !!user.shops[0] ? truncate(user.shops[0].name,13)
                                      :
                                      user.role.name === "user" ?
                                          <Link to="/my-shop">
                                              <Typography varaint="body2"  style={{fontSize:10,color:"#fff",cursor:"pointer"}}>
                                              {Translate.beSupplier}
                                            </Typography>
                                          </Link>
                                          :
                                          user.role.name === "agent" ?
                                              <Link to="/agent">{Translate.agent_panel}</Link>
                                          :
                                          user.role.name === "marketer" ?
                                              <Typography varaint="body2"  style={{fontSize:10,color:"#fff",cursor:"pointer"}}>
                                                  {user.marketer_id}
                                              </Typography>
                                          :
                                      <Link to="/my-shop"><Typography varaint="body2"  style={{fontSize:10,color:"#fff"}}>{Translate.makeYourShop}</Typography></Link>
                              }
                          </Typography>
                      </Grid>
                  </Grid>
              </Grid>
          </Grid>
      </Box>
  );
};
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_color: state.primary_color,
});
export default connect(mstp)(UserInfo);
